import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useMappedState } from "redux-react-hook";
import {
  Grid,
  GridItem,
  PageSection,
  PageSectionVariants,
  Title,
} from "@patternfly/react-core";
import ActivityTable from "../components/activity/ActivityTable";
import ActivityToolbar from "../components/activity/ActivityToolbar";
import { REQUESTED_ACTIVITIES } from "../redux/actions/activityAction";
import { keyValueFilter } from "../utils/filterUtil";

export default () => {
  const mapState = useCallback(
    (state) => ({
      activities: state.activityState.activities,
      isFetchingActivities: state.activityState.isFetchingActivities,
    }),
    []
  );
  const { activities, isFetchingActivities } = useMappedState(mapState);
  const dispatch = useDispatch();

  const [itemCount, setItemCount] = useState(0);
  const [filterValue, setFilterValue] = useState("");

  const filterActivities = useCallback(() => {
    return keyValueFilter(activities, "kerberos", filterValue);
  }, [activities, filterValue]);

  useEffect(() => {
    if (!activities) {
      dispatch({
        type: REQUESTED_ACTIVITIES,
        payload: {},
      });
    }
    const filteredActivity = filterActivities();
    if (filteredActivity) {
      setItemCount(filteredActivity.length);
    }
    setFilteredActivities(filteredActivity);
  }, [dispatch, activities, filterActivities]);

  function handleFilterValueChange(filterValue) {
    setFilterValue(filterValue);
  }

  // filter activities
  const [filteredActivities, setFilteredActivities] = useState(activities);
  const [pageContent, setPageContent] = useState(activities);

  useEffect(() => {
    const filteredActivity = filterActivities();
    if (filteredActivity) {
      setItemCount(filteredActivity.length);
    }
    setFilteredActivities(filteredActivity);
  }, [filterValue, filterActivities]);

  useEffect(() => {
    if (filteredActivities) {
      setPageContent(filteredActivities.slice(0, 10));
    }
  }, [filteredActivities]);

  function renderActivityTables() {
    if (
      activities &&
      filteredActivities &&
      pageContent &&
      !isFetchingActivities
    ) {
      return (
        <Grid hasGutter>
          <GridItem key={`activity-1`} span={12}>
            <ActivityToolbar
              handleFilterValueChange={handleFilterValueChange}
              itemCount={itemCount}
              page={1}
              perPage={10}
              setPageContent={setPageContent}
              allPageContent={filteredActivities}
            />
            <ActivityTable activities={pageContent} />
          </GridItem>
        </Grid>
      );
    }
  }

  function renderHeader() {
    if (!activities || !filteredActivities || isFetchingActivities) {
      return <div>Loading...</div>;
    } else {
      return (
        <>
          <Title
            headingLevel="h1"
            size="4xl"
            className="pf-c-title--PaddingTop"
          >
            Activity
          </Title>
        </>
      );
    }
  }

  function renderBody() {
    if (!activities || !filteredActivities || isFetchingActivities) {
      return <div>Loading...</div>;
    } else {
      return renderActivityTables();
    }
  }

  return (
    <>
      <PageSection variant={PageSectionVariants.light}>
        {renderHeader()}
      </PageSection>
      <PageSection>{renderBody()}</PageSection>
    </>
  );
};
